<template>
	<div class="LiveShopBox">
		<div class="common-header-wrap">
			<mt-header class="common-header" title="Live Streaming">
				<mt-button icon="back" slot="left" @click="$router.go(-1)"></mt-button>		
			</mt-header>
		</div>
		<div class="ShopCompanyinformationBox">
			<div class="ShopCompanyHeader">
				<div class="ShopCompanylogo">
					<img :src="imgurl+shopdetails.store_id+'/'+shopdetails.store_avatar" />
				</div>
				<div class="ShopCompanyName">
					<p>{{shopdetails.store_company_name}}</p>
				</div>
			</div>
			<div class="ShopCompanyimgBox">
				<!--<img :src="shopdetails.store_img" />-->
			</div>
			
			<div class="ShopCompanyinformationContent">
				<h5>On Live </h5>
				<div class="LiveBroadcastBox">
					<ul>
						<li :items="live_list" :index="index" v-bind:key="index" v-for="(item, index) in live_list" @click="livedetails(item.live_apply_id)">
							<div class="proinforimgbaox">
								<img class="pros" :src="'https://img.duoyp.com/home/live_apply/'+shopdetails.store_id+'/'+item.live_apply_cover_image" />
								<img class="plays" src="https://trust-data.oss-cn-shenzhen.aliyuncs.com/file/upload/20220513/401_1652441172795989.png" />
							</div>
							<div class="ExhibitorsLiveTitle">
								<p>{{item.live_apply_name}}</p>
							</div>
							<span v-if="item.live_apply_push_state == 1" class="state"><i></i>On Live</span>
							<span v-else-if="item.live_apply_push_state == 2 || item.live_apply_push_state == 0" class="state"><i></i>Pause</span>
						</li>

					</ul>
				</div>
			</div>
			
			<div class="ShopCompanyinformationContent">
				<h5>Playback</h5>
				<div class="LiveBroadcastBox">
					<ul>
						<li :items="playback_list" :index="index" v-bind:key="index" v-for="(item, index) in playback_list" @click="livedetails(item.live_apply_id)">
							<div class="proinforimgbaox">
								<img class="pros" :src="'https://img.duoyp.com/home/live_apply/'+shopdetails.store_id+'/'+item.live_apply_cover_image" />
								<img class="plays" src="https://trust-data.oss-cn-shenzhen.aliyuncs.com/file/upload/20220513/401_1652441172795989.png" />
							</div>
							<div class="ExhibitorsLiveTitle">
								<p>{{item.live_apply_name}}</p>
							</div>
							
							<span class="state"><i></i>Playback</span>
						</li>

					</ul>
				</div>
			</div>	
		</div>
		<live-foot></live-foot>
	</div>
	
</template>

<script>
	import LiveFoot from './child/LiveFoot'
	import { joinLivesss } from '../../../api/memberLive'
export default {
  name: 'HomeLiveShop',
  data () {
    return {
      imgurl:'https://img.duoyp.com/home/store/',	
      shopdetails:'',
      playback_list:false,
      live_list: false,
    }
  },
  components: {
    LiveFoot
  },
  mounted () {
  },
  created: function () {
	var storeid=this.$route.query.shopid;
	joinLivesss(storeid).then((res) => {
		this.shopdetails=res.result.live_store;
    	this.live_list = res.result.live_list;
    	this.playback_list=res.result.playback_list
   }).catch(function (error) {
    })
  },
  computed: {
    
  },
  methods: {

	livedetails:function(liveid){
		this.$router.push({ 'name': 'MemberLiveDetail', 'query': { 'live_apply_id': liveid } })
	}

  }
}	
var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?5faea91a582bbeb3f1171e8151061236";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})()

</script>

<style>
	.ShopCompanyinformationBox{}
	.ShopCompanyHeader{background: #fff;text-align: center;}
	.ShopCompanylogo{display: inline-block;width: 30%;text-align: center;box-sizing: border-box;padding: 0 0.3rem;
	height: 3rem;vertical-align: middle;line-height: 3rem;}
	.ShopCompanylogo img{max-width: 100%;max-height: 3rem;}
	.ShopCompanyName{display: inline-block;vertical-align: middle;box-sizing: border-box;padding: 0 0.3rem;}
	.ShopCompanyName p{font-size: 0.6rem;line-height: 1.3rem;color: #000;font-weight: bold;text-align: center;}
	.ShopCompanyimgBox{text-align: center;padding: 0.5rem 0;background: #fff;}
	.ShopCompanyimgBox img{width: 100%;}
	
	.ShopCompanyinformationContent{margin-top: 0.7rem;background: #fff;}
	.ShopCompanyinformationContent h5{font-size: 0.7rem;color: #333;font-weight: 700;padding: 0.5rem 0.3rem;border-bottom: 1px solid #f5f5f5;}
	.informationContentLiveas{}
	.informationContentLive ul{margin: 0;padding: 0;}
	.informationContentLive ul li{padding: 7px 0.5rem;border-bottom: 1px solid #f3f3f3;}
	.informationContentLive ul li span{display: inline-block;width: 15%;color: #999;text-align: left;font-size: .65rem;vertical-align: middle;}
	.informationContentLive ul li p{display: inline-block;width: 82%;margin-left: 2%;color: #333;font-size: 0.65rem;vertical-align: middle;}
	
	.informationContentLive p.textcontent{display: block;width: 100%;text-indent: 2em;color: #333;font-size: 0.65rem;line-height: 1rem;padding: 0.3rem 0.3rem;box-sizing: border-box;}
		
	.LiveBroadcastBox ul{overflow: auto;display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;}
	.LiveBroadcastBox ul li{width: 50%;float: left;box-sizing: border-box;display: inline-block;position: relative;padding: 0.5rem 0.3rem;border-top: 1px solid #f5f5f5;}
	.LiveBroadcastBox ul li:nth-child(odd){border-right: 1px solid #f5f5f5;}
	.LiveBroadcastBox ul li .proinforimgbaox{width: 100%;text-align: center;min-height: 5rem;}
	.LiveBroadcastBox ul li .proinforimgbaox img.pros{width: 100%;}
	.LiveBroadcastBox ul li img.plays{width: 30px;display: inline-block;position: absolute;left: 50%;top: 50%;margin-left: -15px;margin-top: -15px;z-index: 10;}
	.ExhibitorsLiveTitle{position: absolute;width: 100%;left: 0px;bottom: 0px;background: rgba(0,0,0,0.7);padding: 0 5px;z-index: 100;box-sizing: border-box;}
	.ExhibitorsLiveTitle p{white-space: nowrap;overflow: hidden;text-overflow: ellipsis;font-size: 0.55rem;color: #fff;line-height: 1.2rem;}
	.LiveBroadcastBox ul li span.state{display: inline-block;padding: 0 8px;line-height: 20px;background: rgba(0,0,0,0.7);font-size: 12px;color: #fff;
	position: absolute;left: 10px;top: 10px;z-index: 30;border-radius: 20px;}
	.LiveBroadcastBox ul li span.state i{display: inline-block;margin-right: 3px;width: 9px;height: 9px;background: #E60012;border-radius: 50%;vertical-align: inherit;}
	
	.RecommendedExhibits{}
	.RecommendedExhibits ul{overflow: auto;display: flex;-ms-flex-wrap: wrap;flex-wrap: wrap;}
	.RecommendedExhibits ul li{width: 50%;float: left;box-sizing: border-box;display: inline-block;position: relative;padding: 0.5rem 0.3rem;border-top: 1px solid #f5f5f5;}
	.RecommendedExhibits ul li:nth-child(odd){border-right: 1px solid #f5f5f5;}
	.ExhibitsImgBox{text-align: center;}
	.ExhibitsImgBox img{width: 100%;}
	.ExhibitsTextBox p{font-size: 0.6rem;color: #333;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 3;-webkit-box-orient: vertical;overflow: hidden;line-height: 1rem;min-height: 3rem;}
	.ExhibitsTextBox p.maidian{font-size: 0.5rem;line-height: 0.8rem;min-height: 2.4rem;color: #FF0000;}
	.ShopCompanyinformationContent span.more{font-size: 0.6rem;color: #333;float: right;position: relative;padding-left: 0.6rem;margin-top: 0.1rem;line-height: 0.8rem;}
.ShopCompanyinformationContent span.more:after{content: "\00BB";position: absolute;font-size: 0.8rem;top: 0;left: 0;top: 0rem;line-height: 0.8rem;}
</style>